import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromotionLandingPageType } from 'src/AppState/LandingPageState/LandingPageState';
import { LandingPageForm } from './LandingPageForm/LandingPageForm';
import { LPListItem } from './LPListItem/LPListItem';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const LandingPage = observer(() => {
    const { landingPageState } = useAppStateContext();

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={landingPageState.isLoading}>
                        <Loader isActive={landingPageState.isLoading}/>
                        {landingPageState.landingPagesSorted !== null && landingPageState.landingPagesSorted.map((LP: PromotionLandingPageType | null) => {
                            return (LP !== null && LP.slug) ? <LPListItem key={LP?.slug} LP={LP} /> : null;
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <LandingPageForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
